import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import styles from '../Cartcontainer/Cartcontainer.module.css'; 
import config from '../../config/config';

const Spcart = () => {
  const [cartItems, setCartItems] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    fetchCart();
  }, []);

  const fetchCart = async () => {
    const token = localStorage.getItem('token');
    
    if (!token) {
      setCartItems([]);
      return;
    }

    try {
      const response = await axios.get(`${config.apiBaseUrl}/api/users/cart`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCartItems(response.data);
    } catch (error) {
      console.error('Failed to fetch cart:', error);
      setCartItems([]);
    }
  };

  const handleRemoveItem = async (productId) => {
    const token = localStorage.getItem('token');
    
    if (!token) return;

    try {
      await axios.delete(`${config.apiBaseUrl}/api/users/cart/${productId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchCart();
    } catch (error) {
      console.error('Failed to remove item:', error);
    }
  };

  const handleBuyNow = (productId, item) => {
    // Get the current path of the URL
    const currentPath = location.pathname;

    // Extract any existing product IDs from the current URL
    const idString = currentPath.startsWith('/buynow/')
      ? currentPath.replace('/buynow/', '')
      : '';
    const existingIds = idString ? idString.split(',') : [];

    // Check if the product ID is already in the list
    if (!existingIds.includes(productId)) {
      existingIds.push(productId); // Add the new product ID if it's not already in the URL
    }

    // Construct the new URL with the updated product IDs
    const newUrl = `/buynow/${existingIds.join(',')}`;

    // Navigate to the new URL
    navigate(newUrl, { state: { product: item } });
  };

  return (
    <div className={styles.cartContainer}>
      {cartItems.length === 0 ? (
        <p className={styles.emptyCart}>Your cart is empty.</p>
      ) : (
        <div className={styles.cartGrid}>
          {cartItems.map(item => (
            <div key={item.productId} className={styles.cartCard}>
                 <img
                src={item.images?.[0]?.url || 'https://via.placeholder.com/150'}
                alt={item.productName}
                className={styles.productImage}
              />
              
              <div className={styles.productInfo}>
                <h3 className={styles.productName}>{item.productName}</h3>
                <p className={styles.productPrice}>NPR {item.price}</p>
                <p className={styles.productQuantity}>Qty: {item.quantity || 1}</p>

                <div className={styles.cartButtons}>
                  <button
                    className={styles.buyNowButton}
                    onClick={() => handleBuyNow(item.productId, item)}
                  >
                    Buy Now
                  </button>

                  <button
                    className={styles.removeButton}
                    onClick={() => handleRemoveItem(item.productId)}
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Spcart;
